// @flow

import parseTemplate from '../../../helpers/parseTemplate';
import { SPLIT_AT_MORE, type Macro } from '../../../helpers/macros';

const parseMacros = (callback: Function) => (content: string, macros: Array<Macro>) => {
  const replacedContent = parseTemplate(content, macros).map(callback);
  const indexOfSplit = replacedContent.indexOf(SPLIT_AT_MORE);
  if (indexOfSplit === -1) {
    return {
      visiblePart: replacedContent.join(''),
      readMoreParts: '',
    };
  }

  const visiblePart = replacedContent.slice(0, indexOfSplit).join('');
  const readMoreParts = replacedContent.slice(indexOfSplit).filter(str => str !== SPLIT_AT_MORE).join('');
  return {
    visiblePart,
    readMoreParts,
  };
};

export default parseMacros;
